import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cm-admin-users',
  templateUrl: './cm-admin-users.component.html',
  styleUrls: ['./cm-admin-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmAdminUsersComponent {

}
